/**
 * The review grid edits spreadsheet-shaped fields. Derived employee objects are
 * returned for display context, but must not be sent back as a competing source
 * of truth when rows are revalidated or committed.
 */
export function toEmployeeImportInput(employee: Record<string, any>) {
  const {
    dematAccounts: _dematAccounts,
    nominees: _nominees,
    boomerangResolution: _boomerangResolution,
    ...input
  } = employee;

  return input;
}
